import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import '../../scss/LikeModal.scss';

class LikeModal extends Component {
  constructor(props) {
    super();
  }

  render() {
    const unlikeMsg = navigator.mozL10n.get('unliked-an-app-msg');
    return (
      <div className="like-modal-wrapper">
        {this.props.liked ? (
          <div className="like-toast" />
        ) : (
          <div className="unlike-toast">
            <p className="unlike-msg">{unlikeMsg}</p>
          </div>
        )}
      </div>
    );
  }
}

export default LikeModal;



/** WEBPACK FOOTER **
 ** ./src/component/LikeModal.js
 **/